<template>
  <div class="original-location mt-4">
    <label class="original-location-label" :for="inputId">
      Where is the original kept?
    </label>
    <v-textarea
      :id="inputId"
      v-model="location"
      outlined
      dense
      rows="2"
      auto-grow
      hide-details
      class="mt-2"
      placeholder="e.g. Original title deed held by ABSA Home Loans, Sandton branch"
      :disabled="saving"
    />
    <div class="d-flex align-center mt-2">
      <v-btn
        depressed
        color="primary"
        :loading="saving"
        :disabled="!hasChanged"
        @click="save"
      >
        Save location
      </v-btn>
      <span v-if="justSaved" class="saved-hint ml-3">Saved</span>
      <span v-if="errorMessage" class="error-hint ml-3">{{
        errorMessage
      }}</span>
    </div>
  </div>
</template>

<script>
  import { UPDATE_TESTATOR_DOCUMENT_LOCATION_MUTATION } from '../../constants/graphql/testator-documents';

  export default {
    name: 'DocumentOriginalLocationField',
    props: {
      document: { type: Object, required: true },
    },
    data() {
      return {
        location: this.document.originalLocation || '',
        saving: false,
        justSaved: false,
        errorMessage: null,
      };
    },
    computed: {
      inputId() {
        return `original-location-${this.document.id}`;
      },
      hasChanged() {
        return this.location !== (this.document.originalLocation || '');
      },
    },
    watch: {
      'document.originalLocation'(value) {
        this.location = value || '';
      },
    },
    methods: {
      async save() {
        this.saving = true;
        this.justSaved = false;
        this.errorMessage = null;
        try {
          await this.$apollo.mutate({
            mutation: UPDATE_TESTATOR_DOCUMENT_LOCATION_MUTATION,
            variables: {
              id: this.document.id,
              originalLocation: this.location,
            },
          });
          this.justSaved = true;
          this.$emit('saved');
        } catch (e) {
          this.errorMessage = 'Could not save. Please try again.';
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>

<style scoped>
  .original-location-label {
    font-size: 14px;
    font-weight: 600;
    color: #282828;
  }
  .saved-hint {
    font-size: 13px;
    color: #15803d;
  }
  .error-hint {
    font-size: 13px;
    color: #b91c1c;
  }
</style>
